/* Contact Profile selectors. */
import STATUS from '../../../common/constants/reducer_statuses'
import { createSelector } from '@reduxjs/toolkit'

// Base selectors with null safety
export const selectContactProfiles = state => state.contactProfiles || {}
export const selectProfiles = state => selectContactProfiles(state).profiles || {}

// User-specific selectors with additional null checks
export const selectUserProfileEntry = userId => state => {
  const profiles = selectProfiles(state) || {}
  return profiles[userId] || { data: null, status: STATUS.IDLE, error: null }
}

export const selectUserProfile = userId => state => {
  const profileEntry = selectUserProfileEntry(userId)(state)
  return profileEntry.data || null
}

export const selectUserProfileStatus = userId => state => {
  const profileEntry = selectUserProfileEntry(userId)(state)
  return profileEntry.status || STATUS.IDLE
}

export const selectUserProfileError = userId => state => {
  const profileEntry = selectUserProfileEntry(userId)(state)
  return profileEntry.error || null
}

export const selectIsUserProfileLoading = userId => state => {
  return selectUserProfileStatus(userId)(state) === STATUS.LOADING
}

export const selectIsUserProfileSuccess = userId => state => {
  return selectUserProfileStatus(userId)(state) === STATUS.SUCCEEDED
}

export const selectIsUserProfileFailed = userId => state => {
  return selectUserProfileStatus(userId)(state) === STATUS.FAILED
}

// Memoized selector creator for better performance
export const makeSelectUserProfile = () =>
  createSelector(
    [
      selectProfiles,
      (_, userId) => userId,
    ],
    (profiles, userId) => {
      const profile = profiles[userId] || { data: null, status: STATUS.IDLE, error: null }
      return profile.data
    }
  )

export const makeSelectUserProfileStatus = () =>
  createSelector(
    [
      selectProfiles,
      (_, userId) => userId,
    ],
    (profiles, userId) => {
      const profile = profiles[userId] || { data: null, status: STATUS.IDLE, error: null }
      return profile.status
    }
  )
